import RegenerateKeyContainer from './containers/RegenerateKeyContainer'

export default RegenerateKeyContainer
